import { useRef, useState } from 'react';
import { record } from '@solimat/solimat-web-endpoint';

interface KilometrajeInfoResponse {
  ImporteKilometraje: number;
}

const getBackendMessage = (error: unknown) => {
  if (!error || typeof error !== 'object') return 'No se pudo obtener el precio por kilómetro.';

  const typedError = error as {
    message?: string;
    response?: {
      data?: string | { response?: string; message?: string };
      statusText?: string;
    };
  };
  const responseData = typedError.response?.data;

  return (
    (typeof responseData === 'string' ? responseData : null) ||
    (typeof responseData === 'object' ? responseData?.response || responseData?.message : null) ||
    typedError.response?.statusText ||
    typedError.message ||
    'No se pudo obtener el precio por kilómetro.'
  );
};

const useGetInfoKilometrajeSolicitudGastosTransporte = () => {
  const [loadingGetInfoKilometrajeSolicitudGastosTransporte, setLoading] = useState(false);
  const [errorGetInfoKilometrajeSolicitudGastosTransporte, setError] = useState<string | null>(null);
  const [dataGetInfoKilometrajeSolicitudGastosTransporte, setData] = useState<KilometrajeInfoResponse | null>(null);
  const requestIdRef = useRef(0);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || '';
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || '';
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoKilometrajeSolicitudGastosTransporte = async (userId: string, fecha: string) => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    setError(null);
    setData(null);

    try {
      const response = await apiRecord.getInfoKilometrajeSolicitudGastosContingenciaProfesionalTransporte(
        userId,
        fecha
      );
      const importeKilometraje = Number(response.data?.ImporteKilometraje);

      if (!Number.isFinite(importeKilometraje) || importeKilometraje <= 0) {
        throw new Error('El precio por kilómetro recibido no es válido.');
      }

      const data: KilometrajeInfoResponse = { ImporteKilometraje: importeKilometraje };

      if (requestId === requestIdRef.current) {
        setData(data);
      }

      return data;
    } catch (error: unknown) {
      if (requestId === requestIdRef.current) {
        setError(getBackendMessage(error));
      }

      throw error;
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  };

  const resetInfoKilometrajeSolicitudGastosTransporte = () => {
    requestIdRef.current += 1;
    setLoading(false);
    setError(null);
    setData(null);
  };

  return {
    getInfoKilometrajeSolicitudGastosTransporte,
    resetInfoKilometrajeSolicitudGastosTransporte,
    loadingGetInfoKilometrajeSolicitudGastosTransporte,
    errorGetInfoKilometrajeSolicitudGastosTransporte,
    dataGetInfoKilometrajeSolicitudGastosTransporte,
  };
};

export default useGetInfoKilometrajeSolicitudGastosTransporte;